import {
  GET_TERMINATION,
  GET_TERMINATION_SUCCESS,
  GET_TERMINATION_FAIL,
  DELETE_TERMINATION,
  DELETE_TERMINATION_SUCCESS,
  DELETE_TERMINATION_FAIL,
  UPDATE_TERMINATION,
  UPDATE_TERMINATION_SUCCESS,
  UPDATE_TERMINATION_FAIL,
  ADD_NEW_TERMINATION,
  ADD_TERMINATION_SUCCESS,
  ADD_TERMINATION_FAIL,
  TERMINATION_LOADING,
  TERMINATION_RESET
} from "./actionType";

export const resetTerminationState = (actionType) => ({
  type: TERMINATION_RESET,
  payload: { actionType },
});

export const getTerminationSuccess = (actionType, data) => ({
  type: GET_TERMINATION_SUCCESS,
  payload: { actionType, data },
});

export const getTerminationFail = (actionType, error) => ({
  type: GET_TERMINATION_FAIL,
  payload: { actionType, error },
});

export const getTermination = data => ({
  type: GET_TERMINATION,
  payload: data,
});

export const getTerminationLoading = () => ({
  type: TERMINATION_LOADING
});

export const deleteTermination = data => ({
  type: DELETE_TERMINATION,
  payload: data,
});

export const deleteTerminationSuccess = data => ({
  type: DELETE_TERMINATION_SUCCESS,
  payload: data,
});

export const deleteTerminationFail = error => ({
  type: DELETE_TERMINATION_FAIL,
  payload: error,
});

export const updateTermination = data => ({
  type: UPDATE_TERMINATION,
  payload: data,
});

export const updateTerminationFail = error => ({
  type: UPDATE_TERMINATION_FAIL,
  payload: error,
});

export const updateTerminationSuccess = data => ({
  type: UPDATE_TERMINATION_SUCCESS,
  payload: data,
});

export const addNewTermination = data => ({
  type: ADD_NEW_TERMINATION,
  payload: data,
});

export const addTerminationSuccess = data => ({
  type: ADD_TERMINATION_SUCCESS,
  payload: data,
});

export const addTerminationFail = error => ({
  type: ADD_TERMINATION_FAIL,
  payload: error,
});